const Empty = () => (
  <h2 className="mt-3 text-lg/6 font-semibold text-white group-hover:text-gray-300">Sorry, no lessons found</h2>
);

export default Empty;
